import { useEffect, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { Operation, useOperationLoaders } from "../../../../operations"
import { Delivery, DeliveryOrder } from "../../../state/types"
import { describeHelpers, Labels } from "../../../../../features/data-types"
import { CompleteDeliveryForm } from "./completeDeliveryForm"
import { deliveryOrderHelpers } from "../../../hooks/deliveryOrderHooks"
import { useDeliveryLoaders } from "../../../loaders/deliveryLoaders"
import { Roadmap, useRoadmapLoaders } from "../../../../logistics"
import { useDeliveryOrderLoaders } from "../../../loaders/deliveryOrderLoaders"
import { TableName } from "../../../../../tables"
import { toList } from "../../../../../utils/listUtils"

export const CompleteDeliveryFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const isDeliveryOrder = tableName === TableName.DELIVERY_ORDERS
    const deliveryOrder = dataType as O<DeliveryOrder>
    const roadmap = dataType as O<Roadmap>

    const [ready, setReady] = useState(false)
    const [deliveries, setDeliveries] = useState<Delivery[]>([])
    const [deliveryOrders, setDeliveryOrders] = useState<DeliveryOrder[]>([])
    const [operations, setOperations] = useState<Operation[]>([])

    const { describeCode } = describeHelpers
    const { getDeliveryMethodRoutPath } = deliveryOrderHelpers

    const operationLoaders = useOperationLoaders()
    const deliveryLoaders = useDeliveryLoaders()
    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const roadmapLoaders = useRoadmapLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const load = async () => {
        let loadedDeliveries: Delivery[] = []
        if (isDeliveryOrder) {
            const { loadOrderDeliveries } = deliveryLoaders()
            loadedDeliveries = await loadOrderDeliveries(deliveryOrder!.id)
            setDeliveries(loadedDeliveries.filter(delivery => !delivery.cancelled))
            setDeliveryOrders(toList(deliveryOrder))
            const { loadOperation } = operationLoaders()
            const loadedOperation = await loadOperation(deliveryOrder!.table, deliveryOrder!.operationId)
            setOperations(toList(loadedOperation))
        } else {
            const { loadRoadmapDeliveriesLinks } = roadmapLoaders()
            const loadedDeliveryRoadmaps = await loadRoadmapDeliveriesLinks(roadmap!.id)
            const deliveryIds = loadedDeliveryRoadmaps.map(deliveryRoadmap => deliveryRoadmap.deliveryId)
            const { loadDeliveries } = deliveryLoaders()
            loadedDeliveries = await loadDeliveries(deliveryIds)
            setDeliveries(loadedDeliveries)
            const { loadDeliveryOrders } = deliveryOrderLoaders()
            const deliveryOrderIds = loadedDeliveries.map(delivery => delivery.orderId!)
            const loadedDeliveryOrders = await loadDeliveryOrders(deliveryOrderIds)
            setDeliveryOrders(loadedDeliveryOrders)
            const { loadDeliveriesOperations } = operationLoaders()
            const loadedOperations = await loadDeliveriesOperations(loadedDeliveries)
            setOperations(loadedOperations)
        }
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const crumbs = useGetCrumbs(
        isDeliveryOrder ? `Órdenes de ${Labels.deliveryMethodLabel(deliveryOrder!.method)}` : 'Hojas de Ruta',
        isDeliveryOrder ? getDeliveryMethodRoutPath(deliveryOrder!.method) : RoutePath.ROADMAPS,
        describeCode(isDeliveryOrder ? deliveryOrder! : roadmap!),
        isDeliveryOrder ? deliveryOrder!.id : roadmap!.id,
        'Completar Envío'
    )

    return (
        <PanelLoader
            title="Completar Envío"
            crumbs={crumbs}
            ready={ready}
        >
            <CompleteDeliveryForm
                deliveries={deliveries}
                deliveryOrders={deliveryOrders}
                operations={operations}
            />
        </PanelLoader>
    )
}
